interface ColorBandProps {
	className?: string;
}

/**
 * Four-stripe color band (periwinkle, teal, coral, orange).
 * SVG scales to fill container width and height via preserveAspectRatio="none".
 */
export default function ColorBand({ className = "" }: ColorBandProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 4 1"
			preserveAspectRatio="none"
			className={className}
			aria-hidden
		>
			<rect width="1" height="1" fill="#6f7ff9" />
			<rect x="1" width="1" height="1" fill="#7cdac7" />
			<rect x="2" width="1" height="1" fill="#f0c4b8" />
			<rect x="3" width="1" height="1" fill="#ffb700" />
		</svg>
	);
}
